/**
 * Food Categories Configuration
 * This file contains the food categories for the restaurant
 * Can be easily replaced with API calls in the future
 */

export const foodCategories = [
  {
    id: 'burgers',
    name: 'Burgers',
    displayName: 'Burgers',
    icon: 'LunchDining',
    color: '#ff6b35',
    description: 'Delicious handcrafted burgers with premium ingredients',
    itemCount: 12,
    active: true,
    order: 1,
  },
  {
    id: 'pizza',
    name: 'Pizza',
    displayName: 'Pizza',
    icon: 'LocalPizza',
    color: '#2e7d32',
    description: 'Authentic Italian pizzas with fresh toppings',
    itemCount: 8,
    active: true,
    order: 2,
  },
  {
    id: 'fastfood',
    name: 'Fast Food',
    displayName: 'Fast Food',
    icon: 'Fastfood',
    color: '#1976d2',
    description: 'Quick and delicious fast food options',
    itemCount: 15,
    active: true,
    order: 3,
  },
  {
    id: 'desserts',
    name: 'Desserts',
    displayName: 'Desserts',
    icon: 'Icecream',
    color: '#e91e63',
    description: 'Sweet treats and desserts to satisfy your cravings',
    itemCount: 10,
    active: true,
    order: 4,
  },
  {
    id: 'beverages',
    name: 'Beverages',
    displayName: 'Beverages',
    icon: 'LocalCafe',
    color: '#7b1fa2',
    description: 'Refreshing drinks and beverages',
    itemCount: 6,
    active: true,
    order: 5,
  },
];

/**
 * Get food categories from API (placeholder for future implementation)
 * @returns {Promise<Array>} Array of food categories
 */
export const getFoodCategoriesFromAPI = async () => {
  try {
    // Future API call: const response = await api.get('/food-categories');
    // return response.data;
    
    // For now, return static data
    return new Promise((resolve) => {
      setTimeout(() => resolve(foodCategories), 100);
    });
  } catch (error) {
    console.error('Error fetching food categories:', error);
    return foodCategories;
  }
};

/**
 * Get active food categories only
 * @returns {Array} Array of active food categories
 */
export const getActiveFoodCategories = () => {
  return foodCategories.filter(category => category.active);
};

/**
 * Get food category by ID
 * @param {string} id - Category ID
 * @returns {Object|null} Food category object or null
 */
export const getFoodCategoryById = (id) => {
  return foodCategories.find(category => category.id === id) || null;
};

/**
 * Get food categories sorted by order
 * @returns {Array} Array of sorted food categories
 */
export const getSortedFoodCategories = () => {
  return [...foodCategories].sort((a, b) => a.order - b.order);
};

export default foodCategories;
